module.exports = __webpack_public_path__ + "148b3ebac6d204d4c7003446852a7243.fbx";